import styled from "styled-components";

export const DropOptionsWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropOptionsButton = styled.button`
  border: none;
  background: none;
  padding: 4px;
  cursor: pointer;
`;

export const DropOptionsMenu = styled.div`
  position: absolute;
  margin-top: 8px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  max-width: 150px;
  z-index: 1000;
`;

/**
 * @typedef {Object} DropOptionsItemProps
 * @property {boolean} isLast
 */

export const DropOptionsItem = styled.div.attrs(
  /** @param {DropOptionsItemProps} props */
  (props) => ({
    isLast: props.isLast,
  })
)`
  padding: 12px 20px;
  cursor: pointer;
  font-size: 15px;
  color: #222;
  border-bottom: ${({ isLast }) => (isLast ? "none" : "1px solid #f0f0f0")};
  background: none;
  transition: background 0.18s, color 0.18s, border-radius 0.18s;

  &:hover {
    background: #f2f4f8;
    color: #111;
    border-radius: 4px;
  }
`;

export const DropOptionsItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const DropOptionsItemIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.1em;
`;

export const DropOptionsItemLabel = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
